export const SET_QUERY_PARAMS = 'location/SET_QUERY_PARAMS';
